import { Capacitor } from '@capacitor/core'

export const webAppOrigin = 'https://propertyreadyapp.com'

export function isNativePlatform(): boolean {
  return typeof window !== 'undefined' && Capacitor.isNativePlatform()
}

export function getAppRedirectUrl(path: `/${string}`): string {
  const origin = isNativePlatform() ? webAppOrigin : window.location.origin
  return `${origin}${path}`
}
